import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Box } from '@mui/material';
import Loading from '../Portal/Loading';

export const PHX_EXPLICIT_LOGOUT_KEY = 'phx-explicit-logout';
const SESSION_RESTORE_ALLOWLIST = ['/admin/lexid/organizations']; 
export default function AuthCallback() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) {
      const isExplicitLogout = localStorage.getItem(PHX_EXPLICIT_LOGOUT_KEY) === 'true';

      if (!isExplicitLogout) {
        const lastUrl = localStorage.getItem('phx-lastUrl');
        if (lastUrl) {
          try {
            const lastLoc = JSON.parse(lastUrl);
            if (lastLoc.pathname && SESSION_RESTORE_ALLOWLIST.includes(lastLoc.pathname)) {
              navigate(`${lastLoc.pathname}${lastLoc.search || ''}`);
              return;
            }
          } catch {
            localStorage.removeItem(PHX_EXPLICIT_LOGOUT_KEY);
            localStorage.removeItem('phx-lastUrl');
            navigate('/admin/dashboard');
            return;
          }
        }
      }

      localStorage.removeItem(PHX_EXPLICIT_LOGOUT_KEY);
      localStorage.removeItem('phx-lastUrl');
      navigate('/admin/dashboard');
    }
  }, [auth.isAuthenticated, navigate]);

  useEffect(() => {
    if (auth.error) {
      console.error('Error during authentication:', auth.error);
      navigate('/admin/dashboard');
    }
  }, [auth.error, navigate]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (auth.isLoading) {
        console.warn('Auth callback timeout, redirecting to dashboard');
        navigate('/admin/dashboard');
      }
    }, 15000);

    return () => clearTimeout(timeout);
  }, [auth.isLoading, navigate]);

  if (auth.isLoading) {
    return <Loading />;
  }

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Loading />
    </Box>
  );
}
